import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/offline/merchant/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/offline/merchant/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/offline/merchant/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/offline/merchant/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/offline/merchant/update', params,options)

export const updateStatus = (params, options) =>
  request.post('/api/v4ward/offline/merchant/updateStatus', params,options);

